import {
  TextField,
  type TextFieldProps as MuiTextFieldProps,
} from '@mui/material';
import { type UseControllerReturn } from 'react-hook-form';
import styles from './styles';

type CustomTextFieldProps = MuiTextFieldProps & {
  field?: UseControllerReturn['field'];
};

const CustomTextField = ({
  field,
  size = 'small',
  fullWidth = true,
  slotProps,
  ...props
}: CustomTextFieldProps) => (
  <TextField
    {...field}
    {...props}
    sx={styles.textField}
    size={size}
    fullWidth={fullWidth}
    slotProps={{
      inputLabel: { shrink: true },
      ...slotProps,
    }}
  />
);

export default CustomTextField;
